/* eslint no-console:0 */

import "../stylesheets/application.scss"

import Turbolinks from "turbolinks"

import 'babel-polyfill'
import bugsnag from "@bugsnag/js"
import bugsnagVue from "@bugsnag/plugin-vue"
import Vue from "vue/dist/vue.esm"
import Vuex from "vuex"
import VeeValidate, {Validator} from 'vee-validate';
import ja from 'vee-validate/dist/locale/ja';
import Buefy from 'buefy'
import axios from 'axios'
import http from '../packs/axios'
import qs from 'qs'
import store from '../packs/store'
import moment from 'vue-moment'

Turbolinks.start();

const bugsnagClient = bugsnag('57cc3588bfd8901c2ff04e3d72af12f2')
bugsnagClient.use(bugsnagVue, Vue)

Vue.use(Buefy, {
  defaultMonthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  defaultDayNames: ['日', '月', '火', '水', '木', '金', '土']
})
Vue.use(Vuex)
Vue.use(moment)
Vue.use(VeeValidate, {
  validity: true,
  events: 'input',
  inject: false,
});
Validator.localize('ja', ja);
Vue.prototype.$http = http
Vue.prototype.$qs = qs

// a counter for active requests, like jQuery.active
window.axiosActive = 0;

axios.interceptors.request.use(config => {
  window.axiosActive += 1;
  return config;
});

axios.interceptors.response.use(response => {
  window.axiosActive -= 1;
  return response;
});

var vms = []

var options = {}
var requireContext = require.context('../options', false, /\.js$/)

requireContext.keys().forEach(key => {
  let name = key.split('/').pop().split('.').shift()
  options[name] = requireContext(key).default
})

document.addEventListener('turbolinks:load', () => {
  let templates = document.querySelectorAll('[data-vue]')
  for (let el of templates) {
    let vm = new Vue(
      Object.assign(options[el.dataset.vue], { el, store })
    )
    vms.push(vm)
  }

  // ハンバーガーメニューの開閉
  for(const burger of document.getElementsByClassName('navbar-burger')) {
    const menuId = burger.dataset.target
    const menu = document.getElementById(menuId)
    burger.addEventListener('click', e => {
      burger.classList.toggle('is-active')
      menu.classList.toggle('is-active')
    })
  }
})

document.addEventListener('turbolinks:visit', () => {
  for (let vm of vms) {
    vm.$destroy()
  }
  vms = []
})
